import SecondSnapshotRevealPage from 'containers/2nd-snapshot-reveal'

export default SecondSnapshotRevealPage

export const getStaticProps = async () => ({
  props: {
    pageTitle: '2nd Snapshot Reveal',
  },
})
